export function getSellerPath(seller: {
  id: string
  slug?: string | null | undefined
}) {
  return seller.slug ? `/${seller.slug}` : `/sellers/${seller.id}`
}
